import Field from '../../components/Field.jsx';

// The domains allowed to email a shared list's planted contacts. Pasted in any shape:
// domains, email addresses or web addresses, one per line or comma separated (the API
// does the real checking; this only counts them as you type).
export function countDomains(text) {
  const seen = new Set();
  for (const t of String(text || '').split(/[\s,;]+/)) {
    const d = t.trim().replace(/^<|>$/g, '').replace(/^[a-z][a-z0-9+.-]*:\/\//i, '').replace(/[/?#].*$/, '')
      .replace(/^.*@/, '').replace(/^www\./i, '').toLowerCase();
    if (d.includes('.')) seen.add(d);
  }
  return seen.size;
}

export function ApprovedSendersField({ value, onChange, error, max = 500, own = false }) {
  const n = countDomains(value);
  const hint = own
    ? 'Your own domains always count. Add any other domain this system sends from on your behalf (e.g. eventbrite.com).'
    : `Everyone you’re giving the list to, as email domains, web addresses or email addresses. Paste a whole column from your exhibitor list if you like. Up to ${max}. Their proven emails to the planted contacts are expected, so we quietly delete them; only emails from anyone else reach you.`;
  return (
    <>
      <Field as="textarea" rows={own ? 3 : 6} label={own ? 'Other domains it sends from' : 'Approved senders'} optional
        value={value} onChange={onChange} error={error} spellCheck={false} autoCapitalize="none"
        placeholder={own ? 'eventbrite.com' : 'acme-exhibits.com\nsales@brightstands.co.uk\nhttps://www.lumenav.co.uk'}
        hint={!error ? hint : undefined} />
      {n > 0 && <p className="muted small" aria-live="polite" style={{ marginTop: -8 }}>{n} domain{n === 1 ? '' : 's'}{n > max ? `: that’s over the limit of ${max}` : ''}</p>}
    </>
  );
}
